import { CommonFooter } from '../common-footer';
import { CommonHeader } from '../common-header';
import { Footer } from '../footer';
// import { Header } from '../header';
import React from 'react';
import styled from 'styled-components';

interface LayoutProps {
  children: React.ReactNode;
  showCommonFooter?: boolean;
  showFooter?: boolean;
  // showCommonHeader?: boolean; // Remove this prop
}

const LayoutContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
`;

export const Layout: React.FC<LayoutProps> = ({
  children,
  showCommonFooter = false,
  showFooter = false,
}) => {
  return (
    <LayoutContainer>
      <CommonHeader />
      <Main>{children}</Main>
      {showCommonFooter ? (
        <CommonFooter />
      ) : showFooter ? (
        <Footer />
      ) : (
        <Footer />
      )}
    </LayoutContainer>
  );
};
